import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MenuItem, TABLE_SETTINGS } from "./menu.models";
import { MAIN_MENU } from "./menu.models";
import { MemberPreferencesRunItTwice } from "../../../shared/models/member-preferences";
import { ManagerService } from "../../../core/services/manager.service";
import { User } from "../../../shared/models/user";
import { SortCards } from "../../../shared/enums/sort-card";

@Component({
  selector: "app-left-menu",
  templateUrl: "./left-menu.component.html",
  styleUrls: ["./left-menu.component.scss"],
})
export class LeftMenuComponent implements OnInit {
  @Output() itemClicked = new EventEmitter();
  @Input() user: User;
  @Input() languages;
  @Input() contacts;
  @Input() game;
  @Input() MAIN_MENU = null;
  r2t: MemberPreferencesRunItTwice = MemberPreferencesRunItTwice.OFF;
  sordCards: SortCards = SortCards.DEFAULT;
  enumSortCards = SortCards;
  memberPreferencesRunItTwice = MemberPreferencesRunItTwice;
  chipDisplay = "REALISTIC";
  private stack: { title: string; items: MenuItem[] }[];

  constructor(private managerService: ManagerService) {
    this.r2t =
      this.user?.memberProfile?.Preferences?.RunItTwice ??
      MemberPreferencesRunItTwice.OFF;
    this.stack;
  }
  ngOnInit(): void {
    this.stack = [{ title: "Menu", items: this.MAIN_MENU }];
  }

  // MAIN_MENU;
  get title() {
    return this.stack[this.stack.length - 1].title;
  }
  get items() {
    return this.stack[this.stack.length - 1].items;
  }
  get canGoBack() {
    return this.stack.length > 1;
  }
  get logoutItem(): MenuItem {
    return { id: "logout", label: "Logout" };
  }
  onItemClick(item: MenuItem, value?: any) {
    if (item.children?.length) {
      this.stack.push({ title: item.label, items: item.children });
      return;
    }
    this.itemClicked.emit({ itemId: item.id, value: value });
  }
  goBack() {
    if (this.stack.length > 1) this.stack.pop();
  }
}
